<template>
  <div>
    <active-trip
      :type="type"
    />
    <b-card>
      <b-container fluid>
        <b-form @submit.prevent="applySearch">
          <b-row>
            <b-col md="4">
              <label for="states">Search by state</label>
              <v-select
                id="states"
                v-model="currState"
                placeholder="No state selected"
                :options="stateOptions"
                label="label"
                :reduce="(option) => option.key"
                @input="applySearch"
              />
            </b-col>
            <b-col md="4">
              <label for="user">Search by {{ type == 'driver' ? 'User' : 'Driver' }} Phone number</label>
              <b-form-input
                id="user"
                v-model="filterUserNumber"
                type="number"
                placeholder="Phone number"
              />
            </b-col>
            <b-col md="4">
              <label for="trip">Search by trip number</label>
              <b-form-input
                id="trip"
                v-model="tripId"
                type="number"
                placeholder="Trip number"
              />
            </b-col>
          </b-row>
          <b-row class="mb-2">
            <b-col
              md="4"
            >
              <label for="date1">From Date</label>
              <b-form-datepicker
                id="date1"
                v-model="dateTimeFilter.fromDate"
              />
              <label
                class="mt-1"
              >
                From Time</label>
              <b-input-group>
                <flat-pickr
                  v-model="dateTimeFilter.fromTime"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, time_24hr: true}"
                />
                <b-input-group-append>
                  <b-button
                    v-if="dateTimeFilter.fromTime"
                    class="btn-icon"
                    variant="primary"
                    @click="dateTimeFilter.fromTime = ''"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              md="4"
            >
              <label for="date2">To Date</label>
              <b-form-datepicker
                id="date2"
                v-model="dateTimeFilter.toDate"
              />
              <label
                class="mt-1"
                for="time2"
              >To Time</label>
              <b-input-group>
                <flat-pickr
                  v-model="dateTimeFilter.toTime"
                  class="form-control"
                  :config="{ enableTime: true, noCalendar: true, time_24hr: true}"
                />
                <b-input-group-append>
                  <b-button
                    v-if="dateTimeFilter.toTime"
                    class="btn-icon"
                    variant="primary"
                    @click="dateTimeFilter.toTime = ''"
                  >
                    <feather-icon icon="XIcon" />
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-col>
            <b-col
              md="4"
              class="mt-2 d-flex justify-content-between align-items-end"
            >
              <b-button
                variant="primary"
                type="submit"
              >
                Search
              </b-button>
              <b-button
                variant="outline-primary"
                @click="clearFilter"
              >
                Clear
              </b-button>
              <b-button
                class="btn-icon rounded-circle ml-1"
                variant="flat-primary"
                type="submit"
              >
                <feather-icon
                  icon="RefreshCwIcon"
                />
              </b-button>
              <h6>
                Total: {{ totalTrips }}
              </h6>
            </b-col>
          </b-row>
        </b-form>
      </b-container>
      <b-overlay
        variant="white"
        spinner-variant="primary"
        blur="0"
        opacity=".75"
        rounded="sm"
        :show="loading"
      >
        <b-table
          :fields="tableColumns"
          :items="tripsList"
          hover
          striped
          show-empty
          empty-text="No matching trips found"
          class="text-center"
          @row-clicked="redirectToTripDetails"
        >
          <template #cell(state)="data">
            <trip-status-badge :status="data.item.state" />
          </template>
        </b-table>
        <base-pagination
          v-model="queryParams.page"
          :total="totalTrips"
          @input="fetchTripsList"
          @new-per-page="queryParams.perPage = $event"
        />
      </b-overlay></b-card>
  </div>
</template>

<script>
import {
  BTable, BCard, BOverlay, BFormDatepicker, BContainer, BRow, BCol, BButton, BFormInput, BForm,
  BInputGroup, BInputGroupAppend,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import vSelect from 'vue-select'
import useDriverUserTrips from '@/views/driver-user-shared/driver-user-trips/hooks/useDriverUserTrips'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import tripsStore from '@/views/trips/store'
import store from '@/views/driver-user-shared/driver-user-trips/store'
import tripStatusBadge from '@/views/trips/components/TripStatusBadge.vue'
import BasePagination from '@/UI/BasePagination.vue'
import ActiveTrip from './ActiveTrip.vue'

export default {
  components: {
    flatPickr,
    BTable,
    BCard,
    BOverlay,
    tripStatusBadge,
    BasePagination,
    vSelect,
    BFormDatepicker,
    BContainer,
    BForm,
    BRow,
    BCol,
    BButton,
    BFormInput,
    ActiveTrip,
    BInputGroup,
    BInputGroupAppend,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('trips', tripsStore)
    useRegisterStoreModule('driverUsersTrips', store)
    const redirectToTripDetails = $event => {
      const r = ctx.root.$router.resolve(`/trips/${$event.id}`)
      window.open(r.href, '_blank')
    }
    return {
      ...useDriverUserTrips(props, ctx),
      redirectToTripDetails,
    }
  },

}
</script>

<style>

</style>
